import { render, staticRenderFns } from "./GenerationHistoryListItemHead.vue?vue&type=template&id=784d3d24"
import script from "./GenerationHistoryListItemHead.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryListItemHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports